module.exports = __webpack_public_path__ + "static/media/pencil.d0a999cd.svg";